var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "survey-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "course-detail",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "learners",
    transform: "translate(-684.000000, -2888.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "survey-icon",
    transform: "translate(684.000000, 2888.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 6,
    fill: "#FFFFFF",
    x: 3,
    y: 3,
    width: 66,
    height: 66,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 5,
    fill: "#FFFFFF",
    cx: 37.5,
    cy: 34.5,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1261002,24 C38.3219366,24 35.0481907,22.3569571 35,24 C34.9518093,25.6430429 33.1383078,34.3818887 35,35 C35.8362469,35.2776472 38.5533979,37.4061553 41,37 C44.9998203,36.3359982 47.7833484,35.2372004 48,35 C49.9664336,32.8470563 46.3730733,24 43.1261002,24 Z",
    id: "Oval",
    fill: "#7BC440",
    opacity: 0.894042969
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#000000",
    strokeWidth: 4,
    points: "39 20 38 33 52 30"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon);
export default __webpack_public_path__ + "static/media/survey-icon.8f7e7bf34c300387608d8bfe217a4b6c.svg";
export { ForwardRef as ReactComponent };